import React, { useEffect, useRef, useState } from "react";
import SideDrawer from "../../../../Components/sideDrower/SideDrawer";
import { feedCommentApi, feedCommentListApi, updateCommentApi } from "../../../../services/feeds";
import { getTimeDifference } from "../../../../utils/dateTimeFormat";
import { toastMessage } from "../../../../utils/toastMessage";
import { LuSend } from "react-icons/lu";
import { avatar } from "../../../../assets";
import Dropdown from "react-bootstrap/Dropdown";
import { BsThreeDotsVertical } from "react-icons/bs";
import { deleteMessageApi } from "../../../../services/overview";
import { useSelector } from "react-redux";
import { uploadAttachmentApi } from "../../../../services/message";
import { extractedUrlPath } from "../../../../utils/commonHelper";
import { IoImage } from "react-icons/io5";

const OverviewComment = ({ show, close, selectedData, setCommentCount = () => { } }) => {
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState({ content: "" });
  const [type, setType] = useState('');
  const [commentList, setCommentList] = useState([]);
  const commentRef = useRef(null);
  const { showAuth } = useSelector((state) => state?.showAuth);
  const [editMessage, setEditMessage] = useState(false)
  const [image, setImage] = useState([]);
  const fileRef = useRef(null)
  // console.log('image', image)
  // console.log('content', content)
  // console.log('type', type)
  // console.log('commentList', commentList)

  //------------handle-text----------------
  const handleText = (e) => {
    const { name, value } = e.target
    setContent({ ...content, [name]: value, })
    setType("TEXT")
  }

  //---------edit-Comment-Handler-------------
  const editCommentHandler = (data) => {
    setContent({ content: data?.content, id: data?._id })
    setType('TEXT')
    setEditMessage(true)

    // if (data?.type === "MEDIA") {
    //   setImage([{
    //     url: extractedUrlPath(data?.attachments?.[0]?.url),
    //     id: data?._id
    //   }])
    //   setType('MEDIA')
    // } else if (data?.type === "TEXT") {
    //   setContent({ content: data?.content, id: data?._id })
    //   setType('TEXT')
    // }
  }

  // --------when-modal-close-----------------
  const handleClose = () => {
    close()
    setEditMessage(false);
    setContent({ content: "" });
    setType('')
    setImage([])
  }
  //----------add-comment-------------------
  const addCommentHandler = async () => {
    // Check if the comment content is empty
    if (!content.content.trim() && image.length === 0) {
      toastMessage("Comment cannot be empty!", "error", "addCommentOverview");
      return;
    }
    try {
      setLoading(true);
      let payLoad = {};

      let data;
      if (editMessage) {
        payLoad = { content: content?.content, type, _id: content?.id };
        // if (type === 'MEDIA') {
        //   payLoad = { attachments: [{ url: image?.[0]?.url, type: "IMAGE" }], type, _id: image?.[0]?.id };
        // } else if (type === 'TEXT') {
        //   payLoad = { content: content?.content, type, _id: content?.id };
        // }
        const response = await updateCommentApi(payLoad);
        data = response.data;
      } else {
        if (type === 'MEDIA') {
          payLoad = { attachments: [{ url: image?.[0]?.url, type: "IMAGE" }], type, _feed: selectedData?._id };
        } else if (type === 'TEXT') {
          payLoad = { content: content?.content, type, _feed: selectedData?._id };
        }

        const response = await feedCommentApi(payLoad);
        data = response.data;
      }
      // console.log('payLoad', payLoad)
      const { success, message } = data;
      if (success) {
        setEditMessage(false);
        fetchCommentListHandler();
        setContent({ content: "" });
        setType('')
        setImage([])
      } else {
        toastMessage(message, success ? "success" : "error", "addCommentOverview");
      }
    } catch (error) {
      console.error("Error adding/updating comment:", error.message);
      toastMessage("An error occurred. Please try again.", "error", "addCommentOverview");
    } finally {
      setLoading(false);
    }
  };

  //-----------comment-list---------------
  const fetchCommentListHandler = async () => {
    try {
      const { data } = await feedCommentListApi({
        _feed: selectedData?._id,
        limit: 100000000,
        pagination: true,
      });
      const { success, message, data: response, meta } = data;

      if (success) {
        setCommentList(response);
        setCommentCount(meta?.totalRecords);
      } else {
        toastMessage(message, "error", "getOverviewCommentList");
      }
    } catch (e) {
      console.error("Error:-", e.message);
    }
  };

  useEffect(() => {
    if (selectedData?._id) {
      fetchCommentListHandler();
    }
  }, [selectedData?._id]);
  //----------delete-comment------------
  const deleteGroupHandler = async (_id) => {
    try {
      const { data } = await deleteMessageApi({ _id });
      const { success, message } = data;
      if (success) {
        fetchCommentListHandler()
        toastMessage(message, "success", "deleteMessage");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };
  // Handle Enter Key
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !loading) {
      e.preventDefault();
      addCommentHandler();
    }
  };
  useEffect(() => {
    if (commentRef.current) {
      commentRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [commentList]);


  //-----------image-create-url---------------
  const handleFileChange = async (event) => {
    const files = event.target.files;
    if (!files.length) {
      return toastMessage("Please upload an image", "error", "selectMedia");
    }
    const uploadedImages = [];

    for (const file of files) {
      const formData = new FormData();
      formData.append("attachments", file);

      try {
        const { data } = await uploadAttachmentApi(formData);
        const { success, message, data: res } = data;
        // console.log('res', res)
        if (success && res?.length) {
          uploadedImages.push({
            size: res[0]?.size,
            url: res[0]?.key,
            type: "IMAGE",
            showUrl: res[0]?.url,
          });
          setType('MEDIA')
          setContent({ content: file.name })
        }

        toastMessage(message, success ? "success" : "error", "addGroupHandler");
      } catch (e) {
        console.log("Error:-", e.message);
      }
    }

    setImage((prevImages) => [...prevImages, ...uploadedImages]);
  };

  const handleIconClick = () => {
    // document.getElementById("file_picker").click(); // Triggers file input
    if (fileRef?.current) {
      fileRef.current?.click();
    }

  };
  return (
    <SideDrawer show={show} handleClose={handleClose} className={"user-comments-section"}>
      <h3 className="drawer_title">Comments Overview</h3>
      <div className="user_comments">
        <div className="comment_section">
          {commentList && commentList.length > 0
            ? [...commentList].reverse().map((data, ind) => (
              <div key={ind} className="commentt">
                <div className="top_content">
                  <div className="comment_img_content">
                    <img
                      src={data?._user?.profilePicture || avatar}
                      className="avatar"
                    />
                    <p>
                      <b>{data?._user?.fullName}</b>
                      <span>
                        {getTimeDifference(data?.createdAt, Date.now())}
                      </span>
                    </p>
                  </div>
                  {data?._user?._id === showAuth?._id &&
                    <Dropdown>
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <BsThreeDotsVertical />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {data?.type !== 'MEDIA' &&
                          <Dropdown.Item onClick={() => editCommentHandler(data)}>Edit</Dropdown.Item>}
                        <Dropdown.Item onClick={() => deleteGroupHandler(data?._id)}>Delete</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>}
                </div>
                {data?.type === "MEDIA" ?
                  <img src={data?.attachments?.[0]?.url} alt="" />
                  :
                  <p>{data?.content || "---"}</p>}
                <div ref={commentRef} />
              </div>
            ))
            : null}

          <div className="comment_input">
            <input
              type="file"
              id="file_picker"
              ref={fileRef}
              accept="image/*"
              hidden
              onChange={handleFileChange}
            />

            <IoImage
              className="fs-4 overview_imgselect"
              onClick={handleIconClick}
              ref={fileRef}
              style={{ cursor: "pointer" }}
            />

            <input
              type="text"
              className="input_box"
              value={content?.content || ""}
              name="content"
              placeholder="Write comment here..."
              onChange={handleText}
              disabled={type === 'MEDIA'}
              // onChange={(e) =>
              //   setContent({ ...content, content: e.target.value })
              // }
              onKeyDown={handleKeyDown}
            />

            <button className="send_button" onClick={addCommentHandler}>
              <LuSend />
            </button>
          </div>
        </div>
      </div>
    </SideDrawer>
  );
};

export default OverviewComment;
